import React from 'react';
import PropTypes from 'prop-types';
import {
  VIN_HAS_INCORRECT_FORMAT,
  VIN_IS_NOT_LOCATED,
  VIN_HAS_INCORRECT_FORMAT_LENGTH,
} from 'client/site-modules/shared/constants/appraisal/appraisal';

export function VinValidationMessage({
  isError = false,
  isVinValidLength = true,
  isVinValid = true,
  isDecodedVinInvalid = false,
}) {
  if (!isError) {
    return null;
  }

  return (
    <>
      {isVinValidLength && !isVinValid && (
        <div data-testid="vin-incorrect-format-error">{VIN_HAS_INCORRECT_FORMAT}</div>
      )}
      {!isVinValidLength && <div data-testid="vin-incorrect-length-error">{VIN_HAS_INCORRECT_FORMAT_LENGTH}</div>}
      {isDecodedVinInvalid && <div data-testid="vin-not-located-error">{VIN_IS_NOT_LOCATED}</div>}
    </>
  );
}

VinValidationMessage.propTypes = {
  isError: PropTypes.bool,
  isVinValidLength: PropTypes.bool,
  isVinValid: PropTypes.bool,
  isDecodedVinInvalid: PropTypes.bool,
};
